var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45239 23V19.4632L13.5042 11.4305C14.1835 10.8311 14.6631 10.2666 14.9429 9.73706C15.2226 9.20754 15.3625 8.71299 15.3625 8.25341C15.3625 7.594 15.2276 7.00954 14.9578 6.5C14.6881 5.98047 14.3084 5.57584 13.8189 5.2861C13.3293 4.98638 12.7548 4.83651 12.0954 4.83651C11.4061 4.83651 10.7966 4.99637 10.2671 5.31608C9.74758 5.62579 9.34295 6.04042 9.05321 6.55994C8.76347 7.06948 8.6286 7.62398 8.64858 8.22343H4.45239C4.45239 6.74478 4.7771 5.46594 5.42651 4.38692C6.07592 3.3079 6.98009 2.47366 8.13904 1.8842C9.29799 1.29473 10.6468 1 12.1854 1C13.5941 1 14.8529 1.30972 15.9619 1.92915C17.0809 2.5386 17.9601 3.39282 18.5995 4.49182C19.2389 5.59083 19.5587 6.86467 19.5587 8.31335C19.5587 9.38238 19.4088 10.2716 19.1091 10.9809C18.8093 11.6803 18.3647 12.3297 17.7753 12.9292C17.1858 13.5186 16.4615 14.188 15.6023 14.9373L9.75757 20.0627L9.42787 19.1635H19.5587V23H4.45239Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1ceae751ce5638d7000f5d1b47620535.svg";
export { ForwardRef as ReactComponent };